import type { SoundClipsLocale } from './en'

export const soundClipsFrCa = {
  list: {
    title: 'Clips Audio',
    loading: 'Chargement des clips audio...',
    error: 'Erreur',
    empty: 'Aucun clip audio trouvé',
    emptyDescription:
      "Il n'y a actuellement aucun clip audio configuré pour ce PBX.",
    noResults: 'Aucun résultat',
    noResultsDescription: 'Aucun clip audio ne correspond à votre recherche.',
    columnName: 'Nom',
    columnFeatureCode: 'Code de fonction',
    columnUpdated: 'Mis à jour',
    columnActions: 'Actions',
    featureCodeNone: 'N/A',
    createButton: '+ Nouveau Clip Audio',
    deleteConfirmTitle: 'Supprimer le clip audio',
    deleteConfirmMessage:
      'Voulez-vous vraiment supprimer « {{name}} »? Cette action est irréversible.',
    deleteConfirmButton: 'Supprimer',
    deleteSuccess: 'Clip audio supprimé.',
    deleteError: 'Échec de la suppression du clip audio.',
    searchPlaceholder: 'Rechercher des clips audio...',
    recordingInfo:
      'Composez *99 depuis votre téléphone pour enregistrer un nouveau clip audio. Composez *100–*109 pour réenregistrer un clip existant.',
    audioLoadError:
      "Impossible de charger l'audio — il devra peut-être être réenregistré.",
  },
  create: {
    title: 'Nouveau Clip Audio',
    nameLabel: 'Nom',
    namePlaceholder: 'Entrez le nom du clip audio',
    featureCodeLabel: 'Code de fonction',
    featureCodeNone: 'Aucun',
    audioFileLabel: 'Fichier audio',
    audioFilePlaceholder:
      'Glissez-déposez un fichier WAV ou MP3 ici, ou cliquez pour parcourir',
    audioFileAccepted: 'WAV, MP3 (max. 25 Mo)',
    cancel: 'Annuler',
    submit: 'Téléverser le clip audio',
    creating: 'Téléversement...',
    success: 'Clip audio créé avec succès.',
    error: 'Échec de la création du clip audio.',
    nameRequired: 'Le nom est requis.',
    audioFileRequired: 'Un fichier audio est requis.',
  },
  edit: {
    title: 'Modifier le clip audio',
    loading: 'Chargement du clip audio...',
    notFound: 'Clip audio introuvable.',
    backToList: '← Retour à la liste',
    nameLabel: 'Nom',
    namePlaceholder: 'Entrez le nom du clip audio',
    featureCodeLabel: 'Code de fonction',
    featureCodeNone: 'Aucun',
    audioFileLabel: 'Remplacer le fichier audio',
    audioFilePlaceholder:
      'Glissez-déposez un nouveau fichier pour le remplacer, ou cliquez pour parcourir',
    audioFileAccepted: 'WAV, MP3 (max. 25 Mo)',
    currentAudio: 'Audio actuel',
    playCurrentAudio: "Lire l'audio actuel",
    stopAudio: 'Arrêter',
    audioLoadError:
      "Impossible de charger l'audio de ce clip — il devra peut-être être réenregistré.",
    createdLabel: 'Créé',
    updatedLabel: 'Dernière mise à jour',
    cancel: 'Annuler',
    submit: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    success: 'Clip audio mis à jour avec succès.',
    error: 'Échec de la mise à jour du clip audio.',
    deleteButton: 'Supprimer le clip audio',
  },
  upload: {
    invalidType:
      'Type de fichier non pris en charge. Veuillez téléverser un fichier WAV ou MP3.',
    tooLarge:
      'Le fichier est trop volumineux. La taille maximale est de 25 Mo.',
  },
} satisfies SoundClipsLocale
